const getDueDateStatus = (dueDate) => {
    if (!dueDate) return null;
    
    const today = new Date();
    const due = new Date(dueDate);
    const diffTime = due - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays < 0) return { status: 'overdue', color: 'danger', text: 'Overdue' };
    if (diffDays === 0) return { status: 'today', color: 'warning', text: 'Due today' };
    if (diffDays <= 3) return { status: 'soon', color: 'warning', text: `Due in ${diffDays} day${diffDays > 1 ? 's' : ''}` };
    return { status: 'future', color: 'info', text: `Due ${due.toLocaleDateString()}` };
};

const getTaskColor = (task) => {
    const dueDateStatus = getDueDateStatus(task.due_date);
    
    // Priority takes precedence over due date for coloring
    if (dueDateStatus?.status === 'overdue') return 'danger';
    if (task.priority_level === 4) return 'danger'; // URGENT - Red
    if (dueDateStatus?.status === 'today') return 'warning';
    if (task.priority_level === 3) return 'warning'; // HIGH - Orange/Yellow
    if (task.priority_level === 2) return 'primary'; // MEDIUM - Blue (darker blue)
    if (task.priority_level === 1) return 'success'; // LOW - Green
    
    return 'light';
};

const getTaskBorderColor = (task) => {
    const color = getTaskColor(task);
    return `border-${color}`;
};

// Always return a border class to maintain consistent layout
const getTaskBorderColorSafe = (task) => {
    return getTaskBorderColor(task) || 'border-light';
};

export { getDueDateStatus, getTaskColor, getTaskBorderColor };
